import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - process.env types are cursed
const pillarLocalDev = process.env.PILLAR_LOCAL_DEVELOPMENT === 'true';
export default function getPillarLocalDevelopment(): boolean | undefined {
	return (
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		(globalThis as GlobalThisWithLocalDevContext).localDevContext?.PILLAR_LOCAL_DEVELOPMENT ??
		pillarLocalDev
	);
}
